import * as z from "zod/v4";

const webhookTopicSchema = z.enum([
  "return",
  "label",
  "shipment",
  "consolidation_shipment",
]);
const webhookKindSchema = z.enum(["redo", "loop"]);

const teamWebhookInputSchema = z.object({
  _id: z.string().optional(),
  url: z.string(),
  bearerToken: z.string(),
  externalId: z.string().nullable(),
  topic: webhookTopicSchema,
  kind: webhookKindSchema,
  status: z.string().optional(),
});

export type TeamWebhookInput = z.infer<typeof teamWebhookInputSchema>;

export const setTeamWebhooks = {
  name: "setTeamWebhooks" as const,
  input: z.object({ webhooks: z.array(teamWebhookInputSchema) }),
  output: z.object({}),
};
